import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { UiFileUploadComponent } from 'src/app/shared/components/ui-file-upload/ui-file-upload.component';
import { UiMainMenuComponent } from 'src/app/shared/components/ui-main-menu/ui-main-menu.component';
import { UiModalFooterComponent } from 'src/app/shared/components/ui-modal-footer/ui-modal-footer.component';
import { UiSelectPatientComponent } from 'src/app/shared/components/ui-select-patient/ui-select-patient.component';
import { LocalFontAwesome } from 'src/app/shared/modules/fontawesome/fontawesome.module';
import { LocalMaterialModule } from 'src/app/shared/modules/material/material.module';
import { CpfPipe } from 'src/app/shared/pipes/cpf.pipe';

@NgModule({
  imports: [
    CommonModule,
    LocalMaterialModule,
    LocalFontAwesome,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    UiMainMenuComponent,
    UiModalFooterComponent,
    UiSelectPatientComponent,
    CpfPipe,
    UiFileUploadComponent,
  ],
  exports: [
    CommonModule,
    LocalMaterialModule,
    LocalFontAwesome,
    FormsModule,
    ReactiveFormsModule,
    UiMainMenuComponent,
    UiModalFooterComponent,
    UiSelectPatientComponent,
    CpfPipe,
    NgxMaskModule,
    UiFileUploadComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
